<template>
    <div class="m-1">

        <!-- Alert: No item found -->
        <b-alert
                variant="danger"
                :show="walletData === undefined"
        >
            <h4 class="alert-heading">
                Error fetching wallet data
            </h4>
            <div class="alert-body p-3">
                No wallet found with this user id. Check
                <b-link
                        class="alert-link"
                        :to="{ name: 'apps-users-list'}"
                >
                    User List
                </b-link>
                for other users.
            </div>
        </b-alert>

        <div v-if="walletData === null" class="mt-4 d-flex align-items-center justify-content-center">
            <b-spinner class=""></b-spinner>
        </div>

        <template v-if="walletData">
            <!-- First Row -->
            <b-row>
                <b-col
                        cols="12"
                        xl="12"
                        lg="12"
                        md="12"
                >
                    <wallet-view-wallet-info-card :wallet-data="walletData" />
                </b-col>
            </b-row>

            <b-row>
                <b-col
                        cols="12"
                        lg="12"
                >
                    <!-- <user-view-user-permissions-card /> -->
                </b-col>
            </b-row>

        </template>

    </div>
</template>

<script>
  import { BAlert, BCol, BLink, BRow, BSpinner } from 'bootstrap-vue'
  import WalletViewWalletInfoCard from './WalletViewWalletInfoCard.vue'
  import { mapActions } from 'vuex'

  export default {
    name : 'WalletView',
    components: {
      BRow,
      BCol,
      BAlert,
      BLink,
      BSpinner,
      // Local Components
      WalletViewWalletInfoCard,
    },

    data(){
      return{
        walletData : null
      }
    },
    methods: {
      ...mapActions("wallet", ["show"]),
    },
    async mounted() {
      const show = await this.show(this.$router.currentRoute.params.id)
      if (show)
        this.walletData= show
    }
  }
</script>

<style>

</style>
